import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/mitra',
    name: 'mitra',
    component: () => lazyLoadView(import('@views/admin/mitra/List.vue')),
    meta: {
      title: 'Daftar Mitra',
    },
  },
  {
    path: '/:operator/:id(\\d+)/mitra/:mitra_id(\\d+)',
    name: 'mitra-detil',
    component: () => lazyLoadView(import('@views/admin/mitra/Detail.vue')),
    meta: {
      title: 'Detail Mitra',
    },
  },
];
